// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ycjhc","avatar":"Card_avatar__RG0sQ","media":"Card_media__5203y","wrapper":"Card_wrapper__zBaiW"};